import { Action } from 'redux/actions'

import { RootState } from 'types'

export default function reduce(state: RootState['userArticleLikes'] = [], action: Action) {
  switch (action.type) {
    case 'USER_ARTICLE_LIKES_SET': {
      return action.payload
    }
    case 'USER_ARTICLE_LIKES_ADD': {
      if (state.some(like => like.id === action.payload)) {
        return state
      }
      return [...state, { id: action.payload }]
    }
    case 'USER_ARTICLE_LIKES_REMOVE': {
      return state.filter(like => like.id !== action.payload)
    }
    default:
      return state
  }
}
